<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script setup >
// props="['width','height','right1Data']"
name: "baseBar";
import { ref, onMounted,defineProps } from "vue";
import * as echarts from "echarts";
const props =defineProps({
  width: {
    type: String,
    default: "100%",
  },
  height: {
    type: String,
    default: "100%",
  },
  listData: {
    type: Object,
    default: () => {},
  },
})
// console.log(props.listData);
const myEcharts = ref(null);

onMounted(() => {

  initChart(props.listData);
});

function initChart(listData) {
  if (myEcharts.value && myEcharts.value.chart) {
    myEcharts.value.chart.dispose();
  }

  const chartInstance = echarts.init(myEcharts.value);
  console.log(listData)
  const time = listData.time
  const data = listData.list
  // const data = [
  //   { name: '温度', data: [26, 23, 19, 22, 28, 26] },
  //   { name: '湿度', data: [20, 36, 55, 32, 15, 18] },
  // ]

  const option= {
    color: ['#01D19B', '#F1E501'],
    tooltip: {
      trigger: 'axis',
      borderWidth: 0,
      backgroundColor: 'rgba(1, 65, 122,0.5)',
      textStyle: { // 添加 textStyle 属性
        color: '#fff' // 设置字体颜色
      },
    },
    legend: {
      icon: 'stack',
      itemWidth: 9,
      itemHeight: 9,
      top:"3%",
      right:"3%",
      textStyle: {
        fontSize: 14,
        color: '#e0e1e2', // 设置字体颜色
        padding: [10, 10] // 设置文字与图例的距离
      },
      itemGap: 20,// 设置图例项之间的间距
      itemStyle: {
        borderWidth: 0
      }
    },
    grid: {
      left: '5%',
      right: '5%',
      bottom: '10%',
      top: '15%',
      containLabel: true,
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,//两侧留白
      axisLine: {
        lineStyle: {
          color: 'rgba(2, 119, 175,.5)',
          width: 2,
          type: 'solid',
        },
        show: true,
        onZero: false // 将 x 轴坐标轴置于最低刻度上
      },
      axisLabel: {
        interval: 0,
        color: 'rgba(255,255,255)', //更改坐标轴文字颜色
        fontSize: 12, //更改坐标轴文字大小
        margin: 20
      },
      axisTick: {
        show: false,
        alignWithLabel: true,
        lineStyle: {
          color: 'rgba(2, 119, 175)', // 刻度线颜色
          width: 2, // 刻度线宽度
        },
        length: 6, // 刻度线的长度
      },
      data: time,
    },
    yAxis: [
      {
        // name: '温度',
        type: 'value',
        min: "0",
        // max: 100,
        splitNumber: 3,
        splitLine: {
          interval: 0,
          show: true, // 开启分割线
          lineStyle: {
            color: 'rgba(6, 88, 142,.8)',
            width: 1,
            type: [6, 3],
          },
        },
        axisTick: {
          show: false
        },
        axisLine: {
          show: false
        },
        axisLabel: {
          color: 'rgba(207, 219, 230)'
        },
        position: 'left',
      }
    ],
    series: [{
      name: '温度',
      type: 'line',
      symbol: 'circle',
      emphasis: {
        focus: 'series',//高亮显示
      },
      symbolSize: 0,
      data: data[0].data,
      smooth: true,//曲线
      itemStyle: {
        // 折线拐点标志的样式
        borderColor: '#FFE400',
        borderWidth: 2
      },
      // z: 2,
      areaStyle: {
        normal: {
          color: new echarts.graphic.LinearGradient(
            0,
            0,
            0,
            1,
            [
              {
                offset: 0,
                color: "rgba(1, 207, 153,0.5)"
              },
              {
                offset: 0.5,
                color: "rgba(1, 207, 153,0.1)"
              },
              {
                offset: 1,
                color: "rgba(1, 207, 153,0)"
              }
            ],
          )
        }
      }
    },
      {
        name: '湿度',
        type: 'line',
        symbol: 'circle',
        symbolSize: 0,
        data: data[1].data,
        smooth: true,//曲线
        itemStyle: {
          //折线拐点标志的样式
          borderColor: '#F1E501',
          borderWidth: 2
        },
        emphasis: {
          focus: 'series',//高亮显示
        },
        areaStyle: {
          normal: {
            color: new echarts.graphic.LinearGradient(
              0,
              0,
              0,
              1,
              [
                {
                  offset: 0,
                  color: "rgba(241, 229, 1,0.3)"
                },
                {
                  offset: 0.5,
                  color: "rgba(241, 229, 1,0.1)"
                },
                {
                  offset: 1,
                  color: "rgba(241, 229, 1,0)"
                }
              ],
            )
          }
        }
      },

    ]
  };// 将你的ECharts配置项放在这里
    chartInstance.setOption(option, true);
}
  window.addEventListener("resize", () => {
    chartInstance.resize();
  });

</script>
<style lang="less"></style>
